import { UserProfile } from './UserProfile'
import { DocumentDataType } from './Document';

export interface LaneRule {
    id: number
    jsonData: string
    ruleDataType: string
    title: string
    triggerType: string
}
export interface CollectionGroup {
    groupUid: string
    groupUsers: UserProfile[]
    isClosed: boolean,
    adminUIds: string[],
    adminIds: number[],
    isLimitedGroupEnabled?: boolean
    isEnableMembersAsAuthors: boolean
}

export interface CollectionViewListItem {
    collectionViewListId: number,
    documentId: string,
    order: number,
}

export interface CollectionLabel {
    id: number
    color: string,
    name: string,
    labelUid: string,
}

export interface CollectionViewList {
    id: number,
    title: string,
    description?: string | null,
    order: number,
    listColor: TaskStatusColor,
    items: CollectionViewListItem[]
    rules?: LaneRule[]
}

export interface CollectionView {
    id: number,
    title: string,
    collectionViewType: string,
    collectionUid: string,
    itemLists: CollectionViewList[]
}

export type ExternalInput = {
    id: number
    creationDateTime: string
    description: string | null
    fieldsToShow: string
    finishMessage: string | null
    headerFileId: string
    inactiveMessage: string | null
    inactiveTitle: string | null
    isAutomaticTitle: boolean
    isRTL: boolean
    labels: string
    state: number
    lastModification: string
    title: string
    type: {
        dataTypeFilter: string
        id: number
    }
    typeId: number
    uid: string
}

export type ExternalFormPayload = {
    collectionId: number, 
    dataMappingId: number, 
    title: string, 
    description: string, 
    fileid: string, 
    fieldsToShow: string,
    labels: string
    finishMessage: string
}

export type ExternalFormUpdatePayload = {
    collectionId: number
    uid?: string
    labels?: string
    state?: number
    inactiveTitle?: string
    inactiveMessage?: string
    title?: string
    description?: string
    finishMessage?: string
    typeId?: number
    isAutomaticTitle?: boolean
    isRTL?: boolean
    fieldsToShow?: string
    headerFileId?: string
}

export interface Collection {
    collectionUid: string
    description: string
    libraryOrder?: number
    icon: string
    title: string
    newColumnTitle?: string | null
    newGroupTasksTitle?: string | null
    groupDefaultStatusColor: TaskStatusColor | null
    defaultView?: string | null
    backgroundUrl?: string | null
    daysToAlertOnUnusedItem: number
    id: number
    externalInputs: ExternalInput[]
    collectionLabels: CollectionLabel[]
    collectionGroup: CollectionGroup
    limitedGroup: CollectionGroup
    allInputsAllowed: boolean
    rules: LaneRule[]
    mailAddressUid?: string | null
    isLimitedGroupEnabled?: boolean
    settings: {
        allowedInputs: DocumentDataType[],
    },
    collectionViews: CollectionView[]
}

export enum TaskStatusColor {
    Grey = 0, // No status

    Yellow = 10, // Active
    Green = 20, // Done
    Red = 30, // Stopped

    // Other colors
    Orange = 40,
    Blue = 50,
    Turquoise = 60,
    Pink = 70,
    Primary = 80,
    Secondary = 90,
    Alternative = 100
}

export const StatusColorMap = {
    [TaskStatusColor.Grey]: '',
    [TaskStatusColor.Yellow]: '#f6df51',
    [TaskStatusColor.Green]: '#23c244',
    [TaskStatusColor.Red]: '#ff4848',
    [TaskStatusColor.Orange]: '#ffbf4a',
    [TaskStatusColor.Blue]: '#1a8bee',
    [TaskStatusColor.Turquoise]: '#13d5f6',
    [TaskStatusColor.Pink]: '#ff64df',
    [TaskStatusColor.Primary]: '#6b13f6',
    [TaskStatusColor.Secondary]: '#bc98fb',
    [TaskStatusColor.Alternative]: '#ff785c',
}

